"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { Spinner, Toast, ToastAvatar, ToastContent, ToastErrorIcon, ToastSide, ToastSuccessIcon, ToastTitle, useToasts } from "@opensea/ui-kit";
import { omit } from "es-toolkit";
import { useEffect, useMemo } from "react";
import { useTranslations } from "use-intl";
import { TransactionReceiptFragment } from "../../../components/TransactionReceipt/TransactionReceipt.fragment";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../../../constants";
import { useRenderImage } from "../../../providers/RenderImageProvider";
import { FlowActions } from "../../../stores/flowStore";
const FETCH_INTERVAL = 500;
const query = graphql(`
    query MintToastStatusQuery(
      $transactionIdentifiers: [TransactionIdentifier!]!
      $itemQuotes: [ItemQuoteInput!]!
      $swapProvider: SwapProviderType!
    ) {
      buyReceipt(
        transactionIdentifiers: $transactionIdentifiers
        itemQuotes: $itemQuotes
        swapProvider: $swapProvider
        action: MINT
      ) {
        status
        itemReceipts {
          __typename
          item {
            id
            imageUrl
          }
        }
        failedItemReceipts {
          __typename
        }
        ...TransactionReceipt
      }
    }
  `, [TransactionReceiptFragment]);
export function MintToast(t0) {
  const $ = _c(49);
  const {
    transactionIdentifier,
    imageUrl,
    itemQuotes,
    isCrossChain: t1,
    flow
  } = t0;
  const isCrossChain = t1 === undefined ? false : t1;
  const t = useTranslations("wallet.MintToast");
  const {
    renderImage
  } = useRenderImage();
  const {
    removeToast
  } = useToasts();
  let t2;
  if ($[0] !== transactionIdentifier) {
    t2 = transactionIdentifier ? [transactionIdentifier] : [];
    $[0] = transactionIdentifier;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== itemQuotes) {
    t3 = itemQuotes.map(_temp);
    $[2] = itemQuotes;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = t3;
  const t5 = isCrossChain ? "RELAY" : "LOCAL_MINT_NFT";
  let t6;
  if ($[4] !== t2 || $[5] !== t4 || $[6] !== t5) {
    t6 = {
      query,
      variables: {
        transactionIdentifiers: t2,
        itemQuotes: t4,
        swapProvider: t5
      },
      context: NETWORK_ONLY_OPERATION_CONTEXT,
      pause: true
    };
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const [result, reexecuteQuery] = useQuery(t6);
  const receipt = result.data?.buyReceipt;
  let t7;
  if ($[8] !== flow || $[9] !== receipt?.status) {
    t7 = function callOnSuccessWhenComplete() {
      if (receipt?.status === "SUCCESS" && flow) {
        FlowActions.onSuccess(flow);
      }
    };
    $[8] = flow;
    $[9] = receipt?.status;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = receipt?.status;
  let t9;
  if ($[11] !== flow || $[12] !== t8) {
    t9 = [t8, flow];
    $[11] = flow;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  useEffect(t7, t9);
  let t10;
  if ($[14] !== isCrossChain || $[15] !== reexecuteQuery || $[16] !== result.data?.buyReceipt || $[17] !== result.fetching || $[18] !== transactionIdentifier) {
    t10 = function pollForReceipt() {
      if (result.fetching) {
        return;
      }
      const status = result.data?.buyReceipt.status;
      if (status !== undefined && status !== "PENDING") {
        return;
      }
      const timerId = setTimeout(() => {
        if (transactionIdentifier || isCrossChain) {
          reexecuteQuery({
            requestPolicy: "network-only"
          });
        }
      }, FETCH_INTERVAL);
      return () => clearTimeout(timerId);
    };
    $[14] = isCrossChain;
    $[15] = reexecuteQuery;
    $[16] = result.data?.buyReceipt;
    $[17] = result.fetching;
    $[18] = transactionIdentifier;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = result.data?.buyReceipt;
  let t12;
  if ($[20] !== isCrossChain || $[21] !== reexecuteQuery || $[22] !== result.fetching || $[23] !== t11 || $[24] !== transactionIdentifier) {
    t12 = [result.fetching, reexecuteQuery, t11, transactionIdentifier, isCrossChain];
    $[20] = isCrossChain;
    $[21] = reexecuteQuery;
    $[22] = result.fetching;
    $[23] = t11;
    $[24] = transactionIdentifier;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  useEffect(t10, t12);
  let t13;
  let t14;
  if ($[26] !== receipt || $[27] !== removeToast) {
    t13 = function removeToastWhenComplete() {
      let timerId_0;
      if (receipt && receipt.status !== "PENDING") {
        timerId_0 = setTimeout(removeToast, 1500);
      }
      return () => clearTimeout(timerId_0);
    };
    t14 = [receipt, removeToast];
    $[26] = receipt;
    $[27] = removeToast;
    $[28] = t13;
    $[29] = t14;
  } else {
    t13 = $[28];
    t14 = $[29];
  }
  useEffect(t13, t14);
  receipt?.status;
  let t15;
  bb0: {
    switch (receipt?.status) {
      case "SUCCESS":
        {}
      case "PARTIAL_SUCCESS":
        {
          let t16;
          if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
            t16 = <ToastSuccessIcon />;
            $[30] = t16;
          } else {
            t16 = $[30];
          }
          t15 = t16;
          break bb0;
        }
      case "FAILED":
        {
          let t16;
          if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
            t16 = <ToastErrorIcon />;
            $[31] = t16;
          } else {
            t16 = $[31];
          }
          t15 = t16;
          break bb0;
        }
      case "PENDING":
        {}
      case undefined:
        {
          let t16;
          if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
            t16 = <Spinner size="sm" />;
            $[32] = t16;
          } else {
            t16 = $[32];
          }
          t15 = t16;
          break bb0;
        }
    }
    t15 = undefined;
  }
  const icon = t15;
  let t16;
  if ($[33] !== receipt?.status || $[34] !== t) {
    t16 = () => {
      switch (receipt?.status) {
        case "SUCCESS":
          {}
        case "PARTIAL_SUCCESS":
          {
            return t("successTitle");
          }
        case "FAILED":
          {
            return t("failedTitle");
          }
        default:
          {
            return t("pendingTitle");
          }
      }
    };
    $[33] = receipt?.status;
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  receipt?.status;
  let t17;
  if ($[36] !== t16) {
    t17 = t16();
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const title = t17;
  const t18 = imageUrl ?? "";
  let t19;
  if ($[38] !== renderImage || $[39] !== t18) {
    t19 = <ToastAvatar renderImage={renderImage} src={t18} />;
    $[38] = renderImage;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== title) {
    t20 = <ToastContent><ToastTitle>{title}</ToastTitle></ToastContent>;
    $[41] = title;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== icon) {
    t21 = <ToastSide>{icon}</ToastSide>;
    $[43] = icon;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t19 || $[46] !== t20 || $[47] !== t21) {
    t22 = <Toast>{t19}{t20}{t21}</Toast>;
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  return t22;
}
function _temp(quote) {
  return omit(quote, ["orderId"]);
}